// extracted by mini-css-extract-plugin
export default {"tableDataRow":"CreateTherapeuticEquivalency_tableDataRow__XMCkR"};